import useGetAvatar from '@/hooks/useGetAvatar';
import { composeUri } from '@/utils/compose';
import { AVATARS } from '@/utils/CONST';
import Box from '@mui/material/Box';
import { split } from 'lodash';
import { DateField, useTranslate } from 'react-admin';
import ExportLabelValue from '@/components/interventions/export-intervention/common/export-label-value';
import ExportSectionBox from '@/components/interventions/export-intervention/common/export-section-box';

interface ExportInterventionDetailsSectionProps {
    interventionId: string;
}

const ExportInterventionDetailsSection = ({ interventionId }: ExportInterventionDetailsSectionProps) => {
    const translate = useTranslate();

    const { avatar: intervention, isLoading: isLoadingInt } = useGetAvatar({
        avatarUriId: composeUri(AVATARS, interventionId),
    });

    if (isLoadingInt) {
        return null;
    }

    if (!intervention) {
        return null;
    }

    return (
        <ExportSectionBox title={translate('intervention.export.section.details')}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 1,
                }}
            >
                {intervention && (
                    <ExportLabelValue
                        label={translate('intervention.list.number')}
                        value={split(intervention.alphaId, ':')[1]}
                    />
                )}

                {intervention?.creationDate && (
                    <ExportLabelValue
                        label={translate('intervention.export.created_at')}
                        value={
                            <DateField
                                record={{
                                    date: intervention?.creationDate,
                                }}
                                options={{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }}
                                source={'date'}
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 400,
                                }}
                            />
                        }
                    />
                )}
            </Box>
        </ExportSectionBox>
    );
};

export default ExportInterventionDetailsSection;
